import React, { FC } from 'react';
import CloseIcon from '~/icons/close.svg';
import SearchIcon from '~/icons/search.svg';
import styles from './RefinementSearchInput.module.scss';

type RefinementSearchInputProps = {
    value?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    placeholder?: string;
    ariaLabel?: string;
};

export const RefinementSearchInput: FC<RefinementSearchInputProps> = ({
    value,
    onChange,
    onClear,
    placeholder,
    ariaLabel = placeholder,
}) => (
    <div className={styles.inputWrapper}>
        <SearchIcon width="24" height="24" />
        <input
            className={styles.dropdownInputField}
            aria-label={ariaLabel}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
        />
        {value && (
            <button className={styles.close} onClick={onClear} aria-label="Clear search">
                <CloseIcon />
            </button>
        )}
    </div>
);
